module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/transport/browser/eventsource.js
// module id = 655
// module chunks = 3